export default "__VITE_ASSET__D0kElnEI__"